import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import { validateString } from '../../common/helperFunctions';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';
import { iState } from '../../models/iState';
import { EditObject } from '../../common/constants';

class Start extends React.Component<CreateSurveyProps, iState> {
    state = {
        validationChecked: false,
        generalErrorMessage: ''
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;

        this.props.SetPropertyCreateSurvey(EditObject.Survey, e.target.name, e.target.value, false, 0, new Date());
    };

    handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.target.value = e.target.value;
        
        this.props.SetPropertyCreateSurvey(EditObject.Survey, e.target.name, e.target.value, false, 0, new Date());
    };

    ValidateAndMoveNext = () => {
        this.setState({...this.state, validationChecked: true});
        if (validateString(true, this.props.survey.name, 1, -1) === false ||
            validateString(true, this.props.survey.titleEn, 1, -1) === false ||
            validateString(true, this.props.survey.titleFr, 1, -1) === false) {

                this.setState({...this.state, generalErrorMessage : 'Please fill out the required fields above' });

                return;
            }

        this.props.MoveNextStep(undefined);
    }

    render() {
        return(
            <React.Fragment>
                <div className="row g-3">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Campaign Name <samp className="text-danger">&nbsp;*</samp></label>
                        <input type="text"
                            value={this.props.survey.name}
                            onChange={this.handleChange}
                            name='name'
                            className="form-control"
                            required
                            placeholder="A unique name for identification"></input>
                        {!validateString(this.state.validationChecked, this.props.survey.name, 1, -1) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>}
                    </div>
                </div>
                <div className="row g-3 mt-5">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">English Campaign Title <samp className="text-danger">&nbsp;*</samp></label>
                        <input type="text"
                            className="form-control"
                            value={this.props.survey.titleEn}
                            onChange={this.handleChange}
                            name='titleEn'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required
                            placeholder="English campaign name visible to end user"></input>
                        {!validateString(this.state.validationChecked, this.props.survey.titleEn, 1, -1) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>}
                    </div>
                </div>
                <div className="row g-3">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">French Campaign Title <samp className="text-danger">&nbsp;*</samp></label>
                        <input type="text"
                            className="form-control"
                            value={this.props.survey.titleFr}
                            onChange={this.handleChange}
                            name='titleFr'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required
                            placeholder="French campaign name visible to end user"></input>
                        {!validateString(this.state.validationChecked, this.props.survey.titleFr, 1, -1) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>}
                    </div>
                </div>
                <div className="row g-3 mt-5">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">English Subheading</label>
                        &nbsp;<a href="markdown" target="_blank">help</a>
                        <textarea className="form-control"
                            value={this.props.survey.startNotesEn}
                            onChange={this.handleTextAreaChange}
                            name='startNotesEn'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required
                            rows={10}
                            placeholder="Campaign name visible to end user"></textarea>
                    </div>
                </div>
                <div className="row g-3">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">French Subheading</label>
                        <textarea className="form-control"
                            value={this.props.survey.startNotesFr}
                            onChange={this.handleTextAreaChange}
                            name='startNotesFr'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required
                            rows={10}
                            placeholder="Campaign name visible to end user"></textarea>
                    </div>
                </div>

                <div className="row g-3">
                    <div className='col-sm-12'>
                        <div className="invalid-feedback d-block pt-1 pb-2">{this.state.generalErrorMessage}</div>
                    </div>
                </div>

                <div className="col-sm-12 mt-5">
                    <button className="btn btn-primary" onClick={() => this.ValidateAndMoveNext()}>Continue</button>
                </div>

            </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Start as any);

